import React from 'react';
import TextRenderer from '../components/TextRenderer';
import CalculationModal from '../components/CalculationModal';
import LoadingView from '../components/LoadingView';
import _ from 'lodash';
import reportTime from '../utils/reportTime';
import ShiftStore from '../stores/ShiftStore';
import CandidateStore from '../stores/CandidateStore';
import moment from 'moment';
import 'moment-timezone';
import connectToStores from 'alt/utils/connectToStores';

@connectToStores
class ShiftDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            chatSwitchChecked: false,
            showCalculationModal: false,
            hourlyRate: null,
            payText: 'Hourly rate is average',
            meter: 76,
            minValue: 1,
            arrowDisabled: true,
            isLoading: false,
            rateSaved: false,
            saveError: false
        };
    }

    static getPropsFromStores() {
        return {
            cStore: CandidateStore.getState()
        };
    }

    static getStores() {
        return [CandidateStore];
    }

    componentDidMount() {
        this.changeMeter();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.shift.id != this.props.shift.id || nextProps.shift.rate != this.props.shift.rate || this.state.hourlyRate === null) {
            this.setState({
                hourlyRate: parseFloat(nextProps.shift.rate),
                chatSwitchChecked: nextProps.shift.chat
            });
            this.forceUpdate();
        }
        if (!_.isEqual(this.props.shift, nextProps.shift)) {
            this.props.getNewPropsCallback();
        }

        if (nextProps.rateSaved != this.state.rateSaved) {
            this.setState({isLoading: false, rateSaved: nextProps.rateSaved});
        }
    }

    getContacts(contacts) {
        let shift_contacts = [];
        contacts.forEach(contact =>{
            shift_contacts.push(
                <p>{contact.name}, {contact.phone}, {contact.email}</p>
            );
        });

        return shift_contacts;
    }

    changeMeter() {
        let input = this.props.shift.rate;
        if (this.refs.rate) {
            input = this.refs.rate.getDOMNode().value.toString().replace(",", ".");
            const dotIndex = input.indexOf(".");
            if (dotIndex > 0) {
                input = input.split(".", 1) + '.' + input.substring(dotIndex+1, dotIndex+2).replace(".", "");
            }
            input = input.replace('/[0-9]./g', "");
        }
        const position = this.props.shift.position;
        const maxDeg = 187;
        const minDeg = -17;
        /* Loading draft shift was not possible because loading ca
        * */
        const bestPay = position ? position.default_pay * 2 : 20;
        let arrowDisabled = false;
        let degrees = 0;
        let text = '';
        if (bestPay == 0 || input/bestPay <= 0) {
            degrees = minDeg;
            text = 'Hourly rate too low';
        } else if (input / bestPay >= 1) {
            degrees = maxDeg + minDeg;
            text = 'Awesome hourly rate!';
        } else {
            degrees = (input / bestPay)*maxDeg - 17;
            if(degrees < 36) {
                text = 'Hourly rate too low';
            } else if (degrees < 109) {
                text = 'Hourly rate is average';
            } else {
                text = 'Awesome hourly rate!';
            }
        }
        if (input <= parseFloat(this.state.minValue) && this.props.shift.status != DJ_CONST.SHIFT_STATUSES.DRAFT) {
            arrowDisabled = true;
        }
        this.setState({meter: degrees, hourlyRate: input, payText: text, arrowDisabled});

        CandidateStore.getPotentialCandidates(position.id, input);
    }

    savePosition(data) {
        const shift = this.props.shift;
        const minValue = this.state.minValue;
        if (data.pay && parseFloat(data.pay) < parseFloat(minValue) && this.props.shift.status != DJ_CONST.SHIFT_STATUSES.DRAFT) {
            this.setState({saveError: true});
        } else {
            this.setState({isLoading: true, saveError: false});
            ShiftStore.updatePosition(shift.id, data);
            this.forceUpdate();
        }

    }

    renderContacts() {
        const shift = this.props.shift || {contacts: undefined};
        if ( shift.contacts.length > 0 ) {
            return [1, 2].map(id => {
                if ( id == 1) {
                    return <h3 className="section-title">Contact persons</h3>;
                } else {
                    return this.getContacts(shift.contacts);
                }
            });
        }
    }

    renderDescriptionAndContacts() {
        const shift = this.props.shift || {contacts: undefined};
        if ( shift.description ) {
            return (
                <div className="tab-section tab-section-2">
                    <h3 className="section-title">Description</h3>
                    <TextRenderer content={shift.description} />
                    {this.renderContacts()}
                </div>
            );
        }
    }

    incrementValue(n) {
        let rate = this.refs.rate.getDOMNode();
        rate.value = parseFloat(this.refs.rate.getDOMNode().value) + n >= 0 ? parseFloat(this.refs.rate.getDOMNode().value) + n : 0;
        this.changeMeter();
    }

    getRate() {
        const shift = this.props.shift;

        if (this.state.hourlyRate === null) {
            return null;
        }

        if (([DJ_CONST.SHIFT_STATUSES.FINISHED, DJ_CONST.SHIFT_STATUSES.CANCELLED, DJ_CONST.SHIFT_STATUSES.ENDED].indexOf(shift.status) > -1) || moment(shift.start_time) < moment()) {
            return (
                <span>
                    <input ref="rate" value={this.state.hourlyRate} type="hidden" />
                    {DJ_CONST.LOCALE_CONF.currency + " " + this.state.hourlyRate}
                </span>
            );
        }

        let arrowDown = <div onClick={this.incrementValue.bind(this, -0.5)} className="arrow-down"></div>;
        let arrowUp = <div onClick={this.incrementValue.bind(this, 0.5)} className="arrow-up"></div>;
        if (this.state.arrowDisabled) {
            arrowDown = <div className="arrow-down gray"></div>;
        }

        let labelClasses = 'form-control form-control-number currency';

        if (DJ_CONST.LOCALE_CONF.currency === '€') {
            labelClasses += ' currency--euro';
        }

        if (this.state.saveError) {
            labelClasses += ' has-error';
        }

        return (
            <label className={labelClasses}>
                {arrowUp}
                <input ref="rate" value={this.state.hourlyRate}
                       onChange={this.changeMeter.bind(this)} type="text"/>
                {arrowDown}
                <span className="error-msg">Rate too low</span>
            </label>
        );
    }

    getSaveRateButton() {
        const shift = this.props.shift;
        if ([DJ_CONST.SHIFT_STATUSES.DRAFT, DJ_CONST.SHIFT_STATUSES.PUBLISHED].indexOf(shift.status) < 0 || moment(shift.start_time) < moment()) {
            return null;
        }

        const pay = this.state.hourlyRate != null ? this.state.hourlyRate : shift.rate;
        const className = "btn btn-green btn-save";
        const onClick =  this.savePosition.bind(this, {pay});

        let saveButton =  <button onClick={onClick} className={className}>Save</button>;
        if (this.state.isLoading) {
            saveButton =
                <button className={className}>
                    <div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div>
                </button>;
        }

        return saveButton;
    }

    render () {
        const shift = this.props.shift;
        const position = this.props.shift.position || {};
        const start_time = moment(shift.start_time).tz(shift.company.timezone);
        const end_time = moment(shift.end_time).tz(shift.company.timezone);
        if (this.state.hourlyRate == null && shift.status != DJ_CONST.SHIFT_STATUSES.DRAFT) {
            return <LoadingView />;
        }

        const shiftDetails = [];
        shiftDetails.push(
            <div className="col col-1">
                <h3 className="section-title">Venue</h3>
                <span>{shift.venue}</span>
            </div>
        );

        if ( shift.formatted_address || (shift.street && shift.city) ) {
            shiftDetails.push(
                <div className="col col-2">
                    <h3 className="section-title">Address</h3>
                    <span>{shift.formatted_address || (shift.street ? shift.street + ', ' : '' ) + shift.city + (shift.zip ? ' ' + shift.zip : '')}</span>
                </div>
            );
        }

        shiftDetails.push(
            <div className="col col-3">
                <h3 className="section-title">Date</h3>
                <span>{start_time.format('MMM D')}</span>
            </div>
        );
        shiftDetails.push(
            <div className="col col-4">
                <h3 className="section-title">Time</h3>
                <span>{reportTime(start_time, end_time)}</span>
            </div>
        );
        if ( shift.dresscode ) {
            shiftDetails.push(
                <div className="col col-5">
                    <h3 className="section-title">Dresscode</h3>
                    <span>{shift.dresscode ? shift.dresscode : 'None'}</span>
                </div>
            );
        }
        shiftDetails.push(
            <div className="col col-6">
                <h3 className="section-title">Status</h3>
                <span>{shift.status}</span>
            </div>
        );

        return (
            <div className={"shift-details" + (this.props.isActive ? " active" : "")}>
                <div className="tab-section tab-section-1 shift-details-cols">
                    {shiftDetails}
                </div>
                {this.renderDescriptionAndContacts()}
                {position.name ?
                    <div>
                        <div className="tab-section tab-section-3">

                            <div className="col col-1 left">
                                <h3 className="section-title">Position</h3>
                                <span>{position.name}</span>
                            </div>

                            <div className="col col-2 left">
                            <h3 className="section-title">Hourly rate</h3>
                            {this.getRate()}
                            {this.getSaveRateButton()}
                            <span className={"data-info " + (this.state.rateSaved ? "saved" : "")}>Saved!</span>
                            </div>
                            <div className="col col-3 right">
                                <div className="meter-large">
                                    <div className="meter-arrow" style={{transform: 'scale(1.4) rotate(' + this.state.meter + 'deg)'}}></div>
                                </div>
                                <div className="meter-info">
                                    <div className="info-title">{this.state.payText}</div>
                                    <div className="info-potential-people">Potential workers: <span className="orange">{this.props.cStore.potentialCandidates} </span></div>
                                    <button className="btn-how" onClick={this.toggleCalculationModal.bind(this, shift.position)}>How is this calculated?</button>
                                </div>
                            </div>
                        </div>
                        <div className="tab-section">
                            <h3 className="section-title">Enable chat</h3>
                            <label className="form-control form-control-switch">
                                <span className="switch-text">{this.renderChatSwitchText()}</span>
                                <input onChange={this.chatSwitchChanged.bind(this)} type="checkbox"
                                       checked={this.state.chatSwitchChecked}
                                       disabled={shift.candidates_hired || ['finished', 'cancelled', 'ended'].indexOf(shift.status) > -1} />
                                <span className="fake-checkbox"></span>
                            </label>
                        </div>
                    </div>
                : ''}
                <CalculationModal toggleModal={this.toggleCalculationModal.bind(this)} isVisible={this.state.showCalculationModal} />
            </div>
        );
    }

    toggleCalculationModal() {
        this.setState({
            showCalculationModal: !this.state.showCalculationModal
        });
    }

    chatSwitchChanged(evt) {
        const chat = evt.nativeEvent.srcElement.checked;

        this.setState({
            chatSwitchChecked: chat
        });

        const shift = this.props.shift;
        ShiftStore.updatePosition(shift.id, {chat});
    }

    renderChatSwitchText() {
        if (this.state.chatSwitchChecked == null) {
            return this.props.shift.chat ? "Yes" : "No";
        }

        if (this.state.chatSwitchChecked) return "Yes";
        else return "No";
    }
}

export default ShiftDetails;



/** WEBPACK FOOTER **
 ** ./app/src/components/ShiftDetails.js
 **/